<!-- 货主列表 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <cargoOwnerAction ref="cargoOwnerAction" v-if="showStatus" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></cargoOwnerAction>
    </el-drawer>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList" :showRefresh="true" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="formList.cargoOwnerList.length>0" :searchList="formList.cargoOwnerList"
					:getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
				</v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" stripe ref="mainTable" @sort-change="sortChange" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column align="center" label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="coName" label="货主名称" sortable min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="coCode" label="货主编号" sortable min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="manageFee" label="货主费率" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="goodManageFee" label="高开费率" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coMax" label="价格范围上限" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coMin" label="价格范围下限" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coMne" label="助记码" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="ormName" label="归属组织" min-width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coSuject" label="科目" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="creditAccount" label="授信额度" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="withdrawCredit" label="提现授信额度" min-width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coPhone" label="手机号" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="coIdcard" label="身份证号" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="leasManager" label="招商经理" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="isUnder" label="是否全国归口企业" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.isUnder == 1">是</el-tag>
            <el-tag size="mini" v-else>否</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column align="center" prop="underName" label="归口企业名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cooperTime" label="合作时间" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.cooperTime">{{$common.getLocalTime(scope.row.cooperTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isYj" label="是否月结" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.isYj == 1">是</el-tag>
            <el-tag size="mini" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="coCreatetime" label="创建时间" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.coCreatetime">{{$common.getLocalTime(scope.row.coCreatetime)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="coState" label="货主状态" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.coState == 1">启用</el-tag>
            <el-tag size="mini" v-if="scope.row.coState == 0">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="rangeType" label="范围计算类型" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.rangeType == 1">按建议售价</el-tag>
            <el-tag size="mini" v-if="scope.row.rangeType == 0">按成本价</el-tag>
            <el-tag size="mini" v-if="scope.row.rangeType == 2">按批次最低售价</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="追加保证金" :visible.sync="dialogTableVisible" width="500px" >
      <el-form size="mini" label-width="80px">
        <el-form-item label="保证金" :rules="[{required: true, trigger: ['blur', 'change']}]">
          <el-input type="number" v-model.trim="sendDataInfo.cashDeposit" :maxlength="$store.state.inputLength">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="保证金流水" :visible.sync="dialogTableVisible1" width="500px">
      <el-table :data="recordList" border size="mini" height="400">
        <el-table-column align="center" property="createTime" label="日期" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{$common.getLocalTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" property="cashDeposit" label="保证金" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-dialog>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

    </div>
    <el-dialog :title="creditType==1?'维护提现授信额度':'维护授信额度'" :visible.sync="dialogMoney" width="500px">
      <el-form size="mini" label-width="80px">
        <el-form-item label="授信额度">
          <el-input type="number" v-model.trim="creditAccount" :maxlength="$store.state.inputLength">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMoney = false">取 消</el-button>
        <el-button type="primary" @click="updateCredit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './otherData.js'
import cargoOwnerAction from "@/components/cargoOwnerAction.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {cargoOwnerAction},
  data() {
    //这里存放数据
    return {
        tableHeight:0,
      showStatus: false,
      actionData: {},
      selectedDataIndex: 0,
      buttonList: [],
      getRequestData: {
        coName: "",
        coCode: "",
        start: new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        page: 1,
        rows: 30,
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      creditType:0,
      dialogMoney: false,
      sendDataInfo: {
        cashDeposit: ''
      },
      creditAccount: '',
      dialogTableVisible: false,
      dialogTableVisible1: false,
      recordList: [],
      sortChangeList: [],
      formList:formList
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openSearch(){},
    // 子组件触发
    drawerCancel(commitData) {
      this.showStatus = false
      commitData && this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }
    },
    sortChange() {
      // console.log('sortChange', this.$refs.mainTable);
      this.sortChangeList = this.$refs.mainTable.tableData;
    },
    
    // 修改状态
    async setDataAction() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.sortChangeList[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.sortChangeList[this.selectedDataIndex];
      var sendData = {
        ids: [dataInfo.coId],
      };
      let responseData = await this.$http.setCarOwnerStatus(sendData);
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType);
      
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0,
            formData: [],
            oldData: '',
            orderId: '',
            printSouce: '',
            printJurId: '',
            type: ''
          }
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
              this.$message({
                message: "暂无数据",
                type: "error",
              });
              return false;
            }
          }
          if (!this.sortChangeList[this.selectedDataIndex]) {
            this.$message({
              message: "请先选择您要操作的数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.sortChangeList[this.selectedDataIndex];
          this.showStatus = true
          this.actionData = {
            cate: 1,
            formData: [],
            oldData: dataInfo,
            orderId: '',
            printSouce: '',
            printJurId: '',
            type: ''
          }
          break;
        case 2:
          this.delDataAction();
          break;
        case 3:
          this.setDataAction();
          break;
        case 4:
          this.addBond();
          break;
        case 5:
          this.bondRecord();
          break;
        case 6:
          this.setCredit(0);
          break;
          case 7:
          this.setCredit(1);
          break;
      }
    },
    setCredit(val) {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      var dataInfo = this.sortChangeList[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      this.creditType=val
      if (val==1) {
        this.creditAccount = dataInfo.withdrawCredit ? dataInfo.withdrawCredit : ''
      }else{
        this.creditAccount = dataInfo.creditAccount ? dataInfo.creditAccount : ''
      }
      this.dialogMoney = true
    },
    async bondRecord() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.sortChangeList[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.sortChangeList[this.selectedDataIndex];
      let responseData = await this.$http.queryCash({ ids: [dataInfo.coId] });
      if (responseData.status == 200) {
        this.recordList = responseData.result
        this.dialogTableVisible1 = true
      } else {
        this.$message({
          message: '查询保证金流水异常',
          type: "error",
        });
      }
    },
    async updateCredit() {
      if (this.creditAccount == '') {
        return this.$message({
          type: "warning",
          message: "请填写授信额度",
        });
      }
      var sendData;
      if (this.creditType==1) {
        sendData={
          withdrawCredit:this.creditAccount,
          coId: this.sortChangeList[this.selectedDataIndex].coId
        }
      }else{
        sendData={
          creditAccount: this.creditAccount,
          coId: this.sortChangeList[this.selectedDataIndex].coId
        }
      }
      let responseData = await this.$http[this.creditType==1?'setWithdrawCredit':"setCreditAccount"](sendData);
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.dialogMoney = false
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    async confirmAdd() {
      if (this.sendDataInfo.cashDeposit == '') {
        return this.$message({
          type: "warning",
          message: "请填写保证金",
        });
      }
      let sendData = {
        cashDeposit: this.sendDataInfo.cashDeposit,
        coId: this.sortChangeList[this.selectedDataIndex].coId
      }
      let responseData = await this.$http.addCash(sendData);
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "追加成功",
        });
        this.dialogTableVisible = false
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 追加保证金
    addBond() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.sortChangeList[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      this.sendDataInfo.cashDeposit = ''
      this.dialogTableVisible = true
      // var dataInfo = this.returnData.list[this.selectedDataIndex];
    },
    // 追加保证金
    addBond() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.sortChangeList[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      this.sendDataInfo.cashDeposit = ''
      this.dialogTableVisible = true
      // var dataInfo = this.returnData.list[this.selectedDataIndex];
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
// 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },

    // 删除数据
    delDataAction() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.sortChangeList[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.sortChangeList[this.selectedDataIndex];
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [dataInfo.coId],
          };
          let responseData = await this.$http.delCarOwner(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        })
        .catch(() => { });
    },

    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getCarOwnerList(this.getRequestData);
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
        this.$nextTick(() => {
          this.sortChangeList = this.$refs.mainTable.tableData;
        })
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var objs=this.$common.getSearch(this.getRequestData,'start','end','page','rows',30)
        for (const key in objs) {
            this.$set(this.getRequestData,key,objs[key])
        }
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
</style>